(() => {
  if (window.HuubSolutionsCardVariantsLoaded) return;
  window.HuubSolutionsCardVariantsLoaded = true;

  const money = (cents) => {
    const value = Number(cents || 0) / 100;
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(value);
  };

  const variantsFor = (root) => {
    try {
      return JSON.parse(root.querySelector('.hs-card-variants-json')?.textContent || '[]');
    } catch (e) {
      return [];
    }
  };

  const imageUrl = (variant) => {
    if (!variant) return '';
    if (typeof variant.featured_image === 'string') return variant.featured_image;
    return variant.featured_image?.src || variant.featured_media?.preview_image?.src || '';
  };

  const setActive = (root, variant) => {
    if (!variant?.options) return;
    root.querySelectorAll('.hs-card-option').forEach((button) => {
      const index = Number(button.dataset.optionIndex);
      const active = variant.options[index] === button.dataset.optionValue;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const updateCard = (root, variant) => {
    const wrapper = root.closest('.product-card-wrapper');
    if (!wrapper || !variant) return;

    setActive(root, variant);

    const selectedImage = imageUrl(variant);
    if (selectedImage) {
      wrapper.querySelectorAll('.card__media .media img').forEach((img) => {
        img.src = selectedImage;
        img.srcset = selectedImage;
        img.removeAttribute('sizes');
      });
    }

    const baseUrl = root.dataset.productUrl || '';
    const variantUrl = baseUrl + (baseUrl.includes('?') ? '&' : '?') + 'variant=' + variant.id;
    wrapper.querySelectorAll('a[href]').forEach((link) => {
      if (link.getAttribute('href')?.includes('/products/') || link.id?.startsWith('CardLink-')) {
        link.href = variantUrl;
      }
    });

    const price = wrapper.querySelector('.price');
    if (price && variant.price != null) {
      const regular = price.querySelector('.price-item--regular');
      const sale = price.querySelector('.price-item--sale');
      const value = money(variant.price);
      if (regular) regular.textContent = value;
      if (sale && !variant.compare_at_price) sale.textContent = value;
    }

    const hiddenVariant = wrapper.querySelector('input.product-variant-id');
    if (hiddenVariant) {
      hiddenVariant.value = variant.id;
      hiddenVariant.disabled = variant.available === false;
    }
  };

  const initRoot = (root) => {
    if (root.dataset.hsInitialized === 'true') return;
    root.dataset.hsInitialized = 'true';
    const variants = variantsFor(root);
    const initial = variants.find((v) => v.available) || variants[0];
    if (initial) setActive(root, initial);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll?.('.hs-card-variants').forEach(initRoot);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.hs-card-option');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    const root = button.closest('.hs-card-variants');
    if (!root) return;
    const variants = variantsFor(root);
    if (!variants.length) return;

    const chosen = {};
    root.querySelectorAll('.hs-card-option.is-active').forEach((b) => {
      chosen[Number(b.dataset.optionIndex)] = b.dataset.optionValue;
    });
    chosen[Number(button.dataset.optionIndex)] = button.dataset.optionValue;

    let variant = variants.find((v) =>
      v.available !== false &&
      v.options.every((value, index) => chosen[index] == null || chosen[index] === value)
    );

    if (!variant) {
      const index = Number(button.dataset.optionIndex);
      variant = variants.find((v) => v.available !== false && v.options[index] === button.dataset.optionValue)
        || variants.find((v) => v.options[index] === button.dataset.optionValue);
    }

    if (variant) updateCard(root, variant);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();